export default __webpack_public_path__ + "static/media/iasmartchef.d34b5135.png";